<template>
  <div :class="['shared-step-editor-accordion-item', {'shared-step-editor-accordion-item__open': open}]">
    <button class="shared-step-editor-accordion-item__button" @click="$emit('clicked', !open)">
      <span>{{ title }}</span>
      <img
        :src="`/wp-content/themes/snappy-theme/assets/images/builders/arrow.svg`"
        :alt="title"
        class="shared-step-editor-accordion-item__icon"
      />
    </button>
    <div v-if="open"><slot /></div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    open: {
      type: Boolean,
      default: false
    },    
  }, 
};
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/web/_variables.scss';

.shared-step-editor-accordion-item {
  &__button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 16px;
    background: #ffffff;
    outline: none;
    font-weight: 700;
    color: $black-color;
    border-bottom: 1px solid #e5e5e5;
  }
  &__icon {
    transition: transform 0.25s;
    transform: rotate(-90deg);
  }
  &__open &__icon {
    transform: rotate(90deg);
  }
}
</style>
